export const sortStagesByPosition = (stages = []) =>
  stages.slice().sort((a, b) => a.position - b.position);
